import styled from "styled-components";

//Assets
import colors from "../../../assets/css/colors";

//Interfaces
import { ButtonShareInterface } from "./interfaces"

export const Container = styled.div`
    width: 100%;
    height: 100%;

    @media (max-width: 650px){

    }
`;

export const ContentContainer = styled.div`
`;

export const FormContainer = styled.div`
    width: 284px;
    margin-right: 151px;

    @media (max-width: 650px){
        width: 100%;
        margin-right: 0px;
        margin-bottom: 50px;
    }
`

export const TextArea = styled.textarea`
    width: 100%;
    height: 98px;

    color: ${colors.tertiary};

    border-radius: 7px;
    border: 1px solid rgba(194, 194, 194, 0.2);

    font-size: 0.8em;
    font-weight: 300;
    line-height: 1.45;

    outline: none;

    padding: 0.4em 1em 0.4em;

    -webkit-transition: 0.18s ease-out;
    -moz-transition: 0.18s ease-out;
    -o-transition: 0.18s ease-out;
    transition: 0.18s ease-out;

    -webkit-box-shadow:  -4px 3px 19px -8px rgba(194, 194, 194, 0.726);
    -moz-box-shadow:  -4px 3px 19px -8px rgba(194, 194, 194, 0.726);
    box-shadow:  -4px 3px 19px -8px rgba(194, 194, 194, 0.726);

    &:hover {
        border: 1px solid rgba(255, 169, 89, 0.2);
        -webkit-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
        -moz-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
        box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
    }

    &:focus {
        color: var(--gray);
        border: 1px solid ${colors.secondaryDark};
        -webkit-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
        -moz-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
        box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
    }

    &:disabled {
        background-color: ${colors.grayLightest};
    }

    &::-webkit-input-placeholder {
        /* WebKit browsers */
        text-transform: none;
    }
    &:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        text-transform: none;
    }
    &::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        text-transform: none;
    }
    &:-ms-input-placeholder {
        /* Internet Explorer 10+ */
        text-transform: none;
    }
    &::placeholder {
        /* Recent browsers */
        text-transform: none;
    }
`;

export const FormTitle = styled.legend`
    font: normal normal normal 14px Circular Std Book;
    color: #454546;
    margin-bottom: 20px;

    @media (max-width: 650px){
        display: flex;
        justify-content: center;
    }
`;

export const TextAreaLegend = styled.h6`
    text-align: right;
    font: normal normal normal 9px Circular Std Book;
    color: #B8B4CC;
    margin: 0;
    margin-bottom: 22px;
`;

export const BalanceContainer = styled.div`
    display: flex;

    margin-bottom: 34px;

    @media (max-width: 650px) {
        flex-direction: column;
        align-items: center;
    }
`;

export const BalanceSendContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;

    width: 121px;

    background: rgba(255,205,139,0.46) 0% 0% no-repeat padding-box;
    border: 1px solid #F58B1E;
    border-radius: 8px;

    padding: 7px 0px 7px 10px;

    margin-right: 19px;

    @media (max-width: 650px) {
        margin-right: 0;
        margin-bottom: 1rem;
    }
`;

export const BalanceSendDescriptionContainer = styled.div`
    margin-left: 12px;
`;

export const BalanceSendDescriptionTitle = styled.h3`
    margin: 0;
    font: normal normal normal 9px Circular Std Book;
    color: #454546;
    line-height: 9px;
    margin-bottom: 2px;
`;

export const BalanceSendDescriptionQuantity = styled.h3`
    margin: 0;
    font: normal normal normal 14px Circular Std Book;
    color: #454546;
    line-height: 14px;
`;

export const ClientsContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;

    width: 121px;

    background: #F6F5FA 0% 0% no-repeat padding-box;
    border: 1px solid #B8B4CC;
    border-radius: 8px;

    padding: 7px 0px 7px 10px;

    margin-right: 19px;

    @media (max-width: 650px) {
        margin-right: 0;
        margin-bottom: 1rem;
    }
`;

export const ClientsNumber = styled.h3`
    margin: 0;
    font: normal normal normal 17px Circular Std Book;
    color: #F58B1E;

    margin-bottom: 2px;
`;

export const ClientsTitle = styled.h3`
    margin: 0;
    font: normal normal normal 9px Circular Std Book;
    color: #454546;
`;

export const ButtonShare = styled.button`
    width: 100%;

    display: flex;
    justify-content: center;
    align-items: center;

    border: ${(p: ButtonShareInterface) =>  `1px solid ${p.color}`};
    color: ${(p: ButtonShareInterface) =>  `${p.color}`};
    border-radius: 7px;
    background-color: ${(p: ButtonShareInterface) =>  `${p.background}`};

    &:focus{
        outline: none;
    }

`

export const ButtonShareText = styled.p`
    font: normal normal 600 14px Muli;
    margin-left: 18px;
    margin-bottom: 0px;
    padding-top: 3px;
`;

export const ModalShareRow = styled.div`
    display: flex;
    justify-content: space-between;

    margin-bottom: 10px;

    
    @media (max-width: 600px) {
       flex-direction: column;
       align-items: center;
       margin-bottom: 1.5rem;
    }
`;

export const ButtonContainer = styled.div`
    width: 284px;
    
    display: flex;

    
    @media (max-width: 600px) {
        width: 100%;
        height: 42px;
        margin-bottom: 1rem;
    }
`;